// extracted by mini-css-extract-plugin
export default {"header":"LogoHeader_header__Fx3Qz"};